import { render } from "./TestimonyCarousel.vue?vue&type=template&id=4733f281&scoped=true"
import script from "./TestimonyCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonyCarousel.vue?vue&type=script&lang=js"

import "./TestimonyCarousel.vue?vue&type=style&index=0&id=4733f281&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4733f281"]])

export default __exports__